import styled from '@emotion/styled';
import { exceptStyledProps, setDeclaration } from '../../utils';
import { Props } from '.';

export const BoxEmotion = styled('div', exceptStyledProps('width', 'display'))<Props>`
  ${props => [
    setDeclaration('display', props.display),
    setDeclaration('justifyContent', props.justifyContent),
    setDeclaration('alignItems', props.alignItems),
    setDeclaration('alignContent', props.alignContent),
    setDeclaration('alignSelf', props.alignSelf),
    setDeclaration('flexBasis', props.flexBasis, 'rem'),
    setDeclaration('flexDirection', props.flexDirection),
    setDeclaration('flexWrap', props.flexWrap),
    setDeclaration('flexGrow', props.flexGrow),
    setDeclaration('flexShrink', props.flexShrink),
    setDeclaration('width', props.width, 'rem'),
    setDeclaration('minWidth', props.minWidth, 'rem'),
    setDeclaration('maxWidth', props.maxWidth, 'rem'),
    setDeclaration('height', props.height, 'rem'),
    setDeclaration('minHeight', props.minHeight, 'rem'),
    setDeclaration('maxHeight', props.maxHeight, 'rem'),
    setDeclaration('margin', props.margin, 'rem'),
    setDeclaration('marginLeft', props.marginLeft, 'rem'),
    setDeclaration('marginRight', props.marginRight, 'rem'),
    setDeclaration('marginTop', props.marginTop, 'rem'),
    setDeclaration('marginBottom', props.marginBottom, 'rem'),
    setDeclaration('padding', props.padding, 'rem'),
    setDeclaration('paddingLeft', props.paddingLeft, 'rem'),
    setDeclaration('paddingRight', props.paddingRight, 'rem'),
    setDeclaration('paddingTop', props.paddingTop, 'rem'),
    setDeclaration('paddingBottom', props.paddingBottom, 'rem'),
    setDeclaration('textAlign', props.textAlign),
    setDeclaration('lineHeight', props.lineHeight)
  ]};
`;
